module.exports = __webpack_public_path__ + "static/media/summary.2d4f2f65.svg";